import React from 'react'
import PropTypes from 'prop-types'

// Components
import Spin from 'antd/lib/spin'
import LoadingOutlined from '@ant-design/icons/LoadingOutlined'

// Styles
import './Loading.scss'

export const Loading = ({ spinning, size, tip, delay, children }) => {
  const spinner = <LoadingOutlined style={{ fontSize: size }} />

  return (
    <Spin
      className="x-loading"
      tip={tip}
      indicator={spinner}
      delay={delay}
      spinning={spinning}
    >
      {children}
    </Spin>
  )
}

// Props
Loading.propTypes = {
  spinning: PropTypes.bool,
  size: PropTypes.number,
  tip: PropTypes.string,
  delay: PropTypes.number,
  children: PropTypes.node,
}

Loading.defaultProps = {
  spinning: false,
  size: 40,
  tip: null,
  delay: 300,
  children: null,
}

export default Loading
